import axios from '../utils/axios';

// 🏢 Get Page Content by Type and Field
export const getValue = async (req) => {
  const response = await axios.get('/api/PageContent/GetValue', {
    params: { 
        type: req.type,
        field: req.field,
        language: req.language
    }
  });
  //console.log(response);
  return response.data;
};

// 🏢 Get Product by Page Content Type and Field
export const getProductByTypeField = async (req) => {
  const response = await axios.get('/api/PageContent/GetListProduct', {
    params: { 
        type: req.type,
        field: req.field
    }
  });
  //console.log(response);
  return response.data;
};


// 🏢 Get Page Content list
export const getPageContentList = async (req) => {
  const response = await axios.get('/api/PageContent/GetList', {
    params: { 
        type: req.type,
        language: req.language
    }
  });
  //console.log(response);
  return response.data;
};

// 🏢 Get All Page
export const getAllPage = async (req) => {
  const response = await axios.get('/api/Page/GetAll');
  //console.log(response);
  return response.data;
};